import { create } from "zustand";

interface WaitlistSidebarHostState {
  container: HTMLDivElement | null;
  hideCloseButton: boolean;
  hostMounted: boolean;
  setHostMounted: (mounted: boolean) => void;
  setContainer: (
    container: HTMLDivElement | null,
    hideCloseButton?: boolean,
  ) => void;
}
export const useWaitlistSidebarHostStore = create<WaitlistSidebarHostState>(
  (set) => ({
    container: null,
    hideCloseButton: false,
    hostMounted: false,
    setHostMounted: (hostMounted) => set({ hostMounted }),
    setContainer: (container, hideCloseButton = false) =>
      set({ container, hideCloseButton }),
  }),
);
